/**
 * Map path patterns to display labels for timeline / recent visits.
 * Dynamic segments (e.g. :staffId) are handled by getPathLabel.
 */
export const PATH_LABELS = {
  "/dashboard": "Dashboard",
  "/notification-center": "My Inbox",
  "/shared-home": "Home",
  "/usermanagement": "User Management",
  "/assign-studies-cro": "Sponsor/CRO management",
  "/userprofile": "User Profile",
  "/externaluserprofile": "User Profile",
  "/rolemanagement": "Role Management",
  "/documenttype": "Document Type",
  "/documentcategory": "Document Category",
  "/sitemanagement": "Site Management",
  "/departments": "Departments",
  "/organizationsetup": "Organisation Setup",
  "/superadmin/organisations": "Customer Organisations",
  "/superadmin/faq-management": "Manage FAQs",
  "/qms": "QMS",
  "/qms/dashboard": "QMS Dashboard",
  "/qms/compliance-report": "QMS Reporting",
  "/qms/document-types": "Document Type",
  "/qms/document-categories": "Document Category",
  "/qms/my-vault": "QMS My Vault",
  "/qms/publish": "QMS Publish",
  "/qms/library": "QMS Library",
  "/qms/change-requests": "QMS Change Requests",
  "/qms/document-control": "QMS Document Control",
  "/qms/tracker": "QMS Document Control",
  "/qms/transfer-ownership": "QMS Document Control",
  "/qms/archive": "QMS Document Control",
  "/qms/my-learnings": "QMS My Learnings",
  "/qms/my-learning": "QMS My Learnings",
  "/qms/my-records": "QMS My Learnings",
  "/superadmin": "Super Admin",
  "/superadmin/qms-config": "QMS Config",
  "/superadmin/eisf-config": "eISF Config",
  "/eisf/document-types": "eISF Document Type",
  "/eisf/document-categories": "eISF Document Category",
  "/commoncomponent": "Common Components",
  "/charts": "Charts",
  "/onlyoffice": "OnlyOffice",
  "/onlineoffice": "Online Office",
  "/isfdashboard": "ISF Dashboard",
  "/isf": "ISF",
  "/isf/reports": "eISF Reports",
  "/isftemplate": "Template Manager",
  "/folder-library": "Folder Library",
  "/milestone-library": "Milestone Library",
  "/milestone-plan": "Milestone Plan",
  "/removeddocuments": "Removed Documents",
  "/downloadauditlog": "Audit Log",
  "/organizations": "Organizations",
  "/studymanagement": "Study Management",
  "/participantmanager": "Participant Manager",
  "/participantmanager/active": "Participant Manager",
  "/participantmanager/inactive": "Participant Manager",
  "/participantmanager/add": "Add Participant",
  "/participantmanager/feasibility": "Feasibility Manager",
  "/participantmanager/feasibility/new": "Create Feasibility",
  "/participantmanager/campaign-templates": "Campaign Templates",
  "/participantmanager/archived-campaigns": "Campaign Templates",
  "/participantmanager/bulk-email-sms": "Bulk Email/SMS",
  "/schedule": "Schedule setup",
  "/capa": "CAPA",
  "/capa-dashboard": "CAPA dashboard",
  "/esource": "e-Source",
  "/esource/templates": "Form Management",
  "/esource/templates/new": "Form Builder",
  "/esource/audit": "Form audit log",
  "/esource/fill": "e-Source form",
  "/epsf": "ePSF",
  "/epsf/forms": "ePSF due forms",
  "/epsf/form-requirements": "ePSF form requirements",
  "/epsf/reports": "ePSF readiness",
  "/epsf/doa": "ePSF Digital DoA",
  "/epsf/inspection": "ePSF inspection",
  "/epsf/imp/products": "IMP Products",
  "/epsf/imp/receipt": "IMP receipt",
  "/epsf/imp/inventory": "IMP inventory",
  "/epsf/imp/transfer": "IMP hub transfer",
  "/epsf/imp/storage": "IMP storage",
  "/epsf/imp/dispense": "IMP dispensing",
  "/epsf/imp/returns": "IMP returns",
  "/epsf/imp/destruction": "IMP destruction",
  "/epsf/imp/accountability": "IMP accountability",
  "/epsf/binder": "ePSF binder",
  "/epsf/folder-library": "ePSF folder library",
  "/epsf/milestone-library": "ePSF milestone library",
  "/epsf/milestone-plan": "ePSF milestone plan",
  "/epsf/templates": "ePSF templates",
  "/esource/instances": "e-Source instances",
  "/faq": "FAQ",
  "/legal-policies": "Legal Policies",
  "/qmspreview": "QMS Preview",
  "/login": "Login",
  "/forgot-password": "Forgot Password",
};

/**
 * @param {string} pathname - e.g. /userprofile/123 or /isf?studyId=1
 * @returns {string} - e.g. "User Profile" or "ISF"
 */
export function getPathLabel(pathname) {
  if (!pathname || pathname === "/") return "Home";
  const pathOnly = pathname.split("?")[0].replace(/\/+$/, "") || "/";
  if (PATH_LABELS[pathOnly]) return PATH_LABELS[pathOnly];
  const base = pathOnly.split("/").filter(Boolean)[0] || "";
  const key = "/" + base;
  return PATH_LABELS[key] || key || pathOnly;
}

const GUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/**
 * Returns subtitle safe for display: never show GUID. "GUID - Study Name" → "Study Name".
 * @param {string} [subtitle]
 * @returns {string}
 */
export function getDisplaySubtitle(subtitle) {
  if (!subtitle || typeof subtitle !== "string") return "";
  const trimmed = subtitle.trim();
  const parts = trimmed.split(/\s*-\s*/);
  if (parts.length >= 2 && GUID_REGEX.test(parts[0].trim())) {
    return parts.slice(1).join(" - ").trim();
  }
  return trimmed;
}
